var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',{attrs:{"metadata":_vm.metadata,"documents-from-request":_vm.documentsFromRequest}})
}
var staticRenderFns = []

export { render, staticRenderFns }